(function() {
    var htmlTemplate = `
<html>
   <head>
		<style>
          @font-face {
              font-family: Montserrat;
              font-style: normal;
              font-weight: 200;
              font-display: swap;
              src: url(https://fonts.gstatic.com/s/montserrat/v15/JTURjIg1_i6t8kCHKm45_aZA7g4.ttf) format("truetype")
          }

          @font-face {
              font-family: Montserrat;
              font-style: normal;
              font-weight: 300;
              font-display: swap;
              src: url(https://fonts.gstatic.com/s/montserrat/v15/JTURjIg1_i6t8kCHKm45_cJD7g4.ttf) format("truetype")
          }

          @font-face {
              font-family: Montserrat;
              font-style: normal;
              font-weight: 400;
              font-display: swap;
              src: url(https://fonts.gstatic.com/s/montserrat/v15/JTUSjIg1_i6t8kCHKm45xW4.ttf) format("truetype")
          }

          @font-face {
              font-family: Montserrat;
              font-style: normal;
              font-weight: 500;
              font-display: swap;
              src: url(https://fonts.gstatic.com/s/montserrat/v15/JTURjIg1_i6t8kCHKm45_ZpC7g4.ttf) format("truetype")
          }

          @font-face {
              font-family: Montserrat;
              font-style: normal;
              font-weight: 700;
              font-display: swap;
              src: url(https://fonts.gstatic.com/s/montserrat/v15/JTURjIg1_i6t8kCHKm45_dJE7g4.ttf) format("truetype")
          }
          body {
              font-family: Montserrat, Verdana;
              padding: 10px;	
          }
        </style>
     	<style>			
          .product-category {
               width: 219px;
               height: 10px;
               left: 439px;
               margin-top: 7px;
               font-size: 10px;
               line-height: 10px;
               color: rgba(26, 25, 25, 0.5);
               text-transform: uppercase;
          }
          .product-size, .product-outfit {
               font-weight: 300;
               width: 219px;
               height: 10px;
               font-size: 10px;
               line-height: 10px;
               color: #1A1A1A;
          }
          .product-note {
               width: 219px;
               height: 77px;
               left: 439px;
               margin-top: 87px;
               font-size: 10px;
               line-height: 12px;
               letter-spacing: 0.02em;
               color: #1A1A1A;
               font-weight: 300;
			   overflow: hidden;	
          }
          .product-container {
               width:219px;
          }
          .product-container-title-price {
               display: flex;
               justify-content: space-between;
          }
          .product-wrapper {
               width: 304px;
               height: 174px;
               display: flex;
               justify-content: space-evenly;
    		   padding-top: 15px;
          }
          table {
              width: 687px;
              max-height: 890px;
              table-layout: fixed;
              margin: auto;
          }
          th {
              position: relative;
              overflow: hidden;
          }
          .table-header-logo {
              width: 100px;
              height: auto;
              position: relative;
              top: -24px;
          }	
          tbody tr:nth-child(5) td {
              padding-top: 20px;
          }
		  tbody tr:nth-child(1) td {
              padding-top: 20px;
          }	
          .print-header-info {
			  display: flex;
              justify-content: space-between;
			  font-size: 12px;
			  font-weight: 100;	
			  line-height: 20px;
			  overflow:hidden;	
			  text-align:left;	
          }	
          .print-header-info > div {
			max-width: 33%;
			padding: 0 15px;
          }	

          .product-image-container {
              width:75px;
              height:174px;
			  margin-right: 10px;
          }
          .product-image {
               width: 100%;
               height:auto 
          }
          .product-title {
               width: 159px;
               height: 10px;
               font-weight: 400;
               font-size: 12px;
               line-height: 12px;
               letter-spacing: 0.1em;
               color: #1A1A1A;
               text-transform: uppercase;
          }
          .product-price {
               color: #666666;
               font-size: 10px;
               line-height: 10px;
               width: 60px;
               height: 10px;
               text-align: right;
          }
          @page {
               size: 687px 890px;
               margin: 0px;
          }
		</style>
   	</head>
   <body>
<table>
`
    
function createHeader(config) {
	return `
            <thead>
                <tr>
                <th colspan="8"><img class="table-header-logo" src='https://cdn.shopify.com/s/files/1/0415/1646/6334/t/3/assets/ETCETERA-LOGO.png'/></th>
                </tr>
                <tr>	
                    <th colspan="8">
                    <div class="print-header-info">
                    <div>
                        <div>${config.storeDetails.clientTitle}</div>
                        <div>${config.storeDetails.clientName}</div>
                    </div>
                    <div>
                        <div>${config.storeDetails.stylistTitle}</div>
                        <div>${config.storeDetails.stylistName}</div>
                     </div>
                    <div>
                        <div>${config.storeDetails.phone}</div>
                        <div>${config.storeDetails.email}</div>
                    </div>
                    </th>
                    </div>
                </tr>
             </thead>
             <tbody>
		 `;
}

function createProductContainer(product) {
	return `
           <td colspan="4">
               <div class="product-wrapper">
                  <div class="product-image-container">
                     <img src= ${product.iu} class="product-image"></img>
                  </div>
                  <div class="product-container">
                     <div class="product-container-title-price">
                        <div class="product-title" >
                           <div>${(product.dt)}</div>
                           <div class= "product-category">${(product.bt)}</div>
                           <div class="product-size" style="margin-top: 18px;">Size: ${product.vi}</div>
                           ${ product.lbls ? `
                           <div class="product-outfit" style="margin-top: 10px;">Capsule: ${product.lbls[0] }</div>
                           ` : `
                           <div></div>
                           `}
                        </div>
                        <div class="product-price">$ ${product.pr}</div>
                     </div>
                     ${ product.note ? `
                     <div class="product-note">Note: ${product.note}</div>
                     ` : `
                     <div></div>
                     `}
                  </div>
               </div>
            </td>
		   `;
}

function PrintWishlist(config) {
  var frameContainer = document.createElement('div');
  var printFrame = document.createElement('iframe');
  			frameContainer.style.position ="relative";
  			frameContainer.style.width = "100%";
  			frameContainer.style.overflow = "hidden";	
            frameContainer.style.paddingTop = "56.25%";	
            printFrame.name = "printFrame"
            printFrame.className = "printFrame"
//             printFrame.style.height= "2600px"
//             printFrame.style.width= "100%"
            printFrame.style.position = "absolute";
            printFrame.style.top = "0";
  			printFrame.style.left = "0";
            printFrame.style.bottom = "0";
            printFrame.style.right = "0";
            printFrame.style.width = "100%";
            printFrame.style.height = "100%";
  			frameContainer.appendChild(printFrame); 
            document.body.prepend(frameContainer);
            var frameDoc = printFrame.contentWindow ? printFrame.contentWindow : printFrame.contentDocument.document ? printFrame.contentDocument.document : printFrame.contentDocument;
            frameDoc.document.open();
            frameDoc.document.write(htmlTemplate);
            frameDoc.document.write(createHeader(config));
            var productContainer = frameDoc.document.querySelector("tbody");
            for (var i = 0; i < config.length ; i++) {
            // when i %2 == 0, add tr
              if (i % 2 === 0) {
                var tr = document.createElement('tr')
                tr.className = 'row-' + i
                var p = createProductContainer(config[i])
                tr.innerHTML += p
              	productContainer.appendChild(tr);
              } else {
              // fetch the row with even number and append productContainer
                var iframe = document.getElementsByName('printFrame')
                var r = iframe[0].contentDocument.getElementsByClassName('row-' + (i - 1))[0]
                var p = r.insertCell(1)
                p.colSpan = "4";
                p.innerHTML = createProductContainer(config[i])
                
              }
            }
            frameDoc.document.write('</table> </body></html>');
            frameDoc.document.close();
            setTimeout(function() {
                window.frames["printFrame"].focus();
                window.frames["printFrame"].print();
                document.body.removeChild(printFrame);
            }, 300);
            return false;
    }
    window.PrintWishlist = PrintWishlist;
})();


(function() {
    function printSwymCallbackFn(swat) {
        var currentStylist = null;
        var handlePrintWithContext = function(listContext) {
          	swat.authCheck(function(ac) {
                var currentStylist = ac.regn.userinfo;
                var clientInfo = listContext.list.details.userinfo // Client info	
                var cfg = {}; // cfg generated with above context
                var storeDetails = {
                    clientName: clientInfo.fname + " " + clientInfo.lname,
                    clientTitle: "CLIENT",
                    stylistTitle: "STYLIST",
                    stylistName: currentStylist.fname + " " + currentStylist.lname,
                    phone: (currentStylist.m ? currentStylist.m : ""),
                  	email: (currentStylist.em ? currentStylist.em : ""),
                    storeName: "Store Name"
                };
              
                cfg = configGenerator(listContext)
                cfg["storeDetails"] = storeDetails
                window.PrintWishlist(cfg)
            });
        }
        window.SwymPrintHandler = handlePrintWithContext
    }

    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(printSwymCallbackFn);
  
function configGenerator(cfg) {
      var updatedConfig = []
      for (var key in cfg) {
          if (cfg.hasOwnProperty(key)) {
              if (key === "filteredListItems") {
                  var val = cfg[key];
                  //  [{}, {} ] 
                  for (var i=0 ;i< val.length; i++) {
                      var item = val[i]
                      updatedConfig.push(item)
                  }
                return updatedConfig;
              }
            
          }
      }
    }                                   
})();




